import React, {useEffect, useState} from 'react';

const DashboardBannerMessage = ({currentUser, type, bannerClass}) => {

  const [message, setMessage] = useState(null);
  
  useEffect(() => {
    fetchMessage();
  }, [])

  const fetchMessage = () => {
    $.ajax({
      type: 'GET',
      url: `/users/${currentUser.id}/fetch_banner_message`,
      dataType: 'json',
      data: {type: type},
      success: function(res) {
        if (res.message) {
          setMessage(res.message);
        }
      }
    })
  }

  if (!message) {
    return <></>;
  } else {
    return (
      <div className='notification-banner-small'>
        <div className={bannerClass}>
          <span className='message'>{message}</span>
        </div>
      </div>
    )
  }
}


export default DashboardBannerMessage;